import {
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	Stack,
	Typography,
	capitalize,
} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {DateFormatEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import {stringfyDate} from 'presentation/utils';
import React from 'react';
import {DataCardProps} from './types';

function DataCard({
	title,
	subtitle,
	footerComponent,
	buttonText,
	handleAction,
	subtitleColor = 'text.secondary',
	noBorderRadius,
	titleColor = 'text.primary',
	dataTest,
	dataTagId,
}: DataCardProps) {
	const {cancelIn, cancelContract} = translations['pt-br'].commons;
	const {isValid, contractCancellationDate} = useContractStatus();
	return (
		<Card data-test={dataTest} elevation={0} sx={{borderRadius: noBorderRadius ? 0 : 1}}>
			<CardContent sx={{pb: title ? 1 : 0.5}}>
				<Box>
					{title ? (
						<Typography color={titleColor} variant="h6">
							{capitalize(title)}
						</Typography>
					) : null}
					<Typography color={subtitleColor} variant={!title ? 'subtitle2' : 'body2'}>
						{capitalize(subtitle)}
					</Typography>
					{!isValid ? (
						<AlertInfo.Root
							severity="warning"
							sx={{padding: '0 0 0 8px', marginTop: '16px'}}>
							<AlertInfo.Description>
								<Typography fontSize={'0.875rem'} component={'span'}>
									{contractCancellationDate ? cancelIn : cancelContract}
									<Typography
										component={'span'}
										fontSize={'inherit'}
										fontWeight={700}>
										{contractCancellationDate
											? stringfyDate(
													contractCancellationDate,
													DateFormatEnum.DATE_FORMAT_8,
												)
											: null}
									</Typography>
								</Typography>
							</AlertInfo.Description>
						</AlertInfo.Root>
					) : null}
				</Box>
			</CardContent>
			<CardActions>
				<Stack direction="row" alignItems="center" p={1} pt={0} flex={1}>
					<Stack flex={1}>{footerComponent}</Stack>
					<Button
						sx={{alignSelf: 'flex-end'}}
						onClick={handleAction}
						variant="text"
						data-tag-id={dataTagId}>
						{buttonText}
					</Button>
				</Stack>
			</CardActions>
		</Card>
	);
}

export {DataCard};
